import { render, staticRenderFns } from "./TehtavatView.vue?vue&type=template&id=0c206d20&scoped=true&xmlns%3Av-touch=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml"
import script from "./TehtavatView.vue?vue&type=script&lang=js"
export * from "./TehtavatView.vue?vue&type=script&lang=js"
import style0 from "./TehtavatView.vue?vue&type=style&index=0&id=0c206d20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c206d20",
  null
  
)

export default component.exports